import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import { Button, Text, TextField } from "../../components";
import { Colors, Fonts } from "../../config";
import {
  MontserratBold,
  MontserratMedium,
  PoppinsMedium,
} from "../../config/fonts";
import { ArtistAction } from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
// import * as Icon from "react-icons/all";
import { MdClose } from "react-icons/md";

const ArtistEmail = ({ data, closeModal }) => {
  const dispatch = useDispatch();
  const artist = useSelector((state) => state.artist);

  const [state, setState] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [error, setError] = useState({
    messageError: "",
  });

  const handleChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });

    setError({
      ...error,
      [e.target.name + "Error"]: "",
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!state.message) {
      setError({ ...error, messageError: "Field can't be empty" });
    } else {
      let apiData = {
        message: state?.message,
        user_id: data?.id,
      };

      dispatch(
        ArtistAction.addEmail(apiData, (res) => {
          closeModal();
          dispatch(
            ArtistAction.getArtistListing({
              limit: 10,
              offset: 0,
              keyword: "",
              status: "",
              role_name: "artist",
            })
          );
        })
      );
    }
  };

  useEffect(() => {
    if (data) {
      setState({
        name: data?.name,
        email: data?.email,
      });
    }
  }, [data]);

  return (
    <>
      <Row justify={"space-between"} className="mb-20">
        <Col>
          <Text.Basic
            color={Colors.Black}
            fontSize={22}
            fontWeight={600}
            fontFamily={Fonts[MontserratBold]}
            text={"Send Email"}
            textAlign="left"
          />
        </Col>
        <Col>
          <MdClose
            color={Colors.Black}
            fontSize={24}
            cursor={"pointer"}
            onClick={closeModal}
          />
        </Col>
      </Row>

      <Row gutter={[25, 25]}>
        <Col span={24} className="mb-5">
          <TextField.Basic
            type={"text"}
            labelFontWeight={600}
            labelFontFamily={Fonts[MontserratMedium]}
            size={"large"}
            value={state.name}
            placeholder={"Name"}
            label="Name"
            disabled={true}
            name="name"
          />
        </Col>

        <Col span={24} className="mb-5">
          <TextField.Basic
            type={"text"}
            labelFontWeight={600}
            labelFontFamily={Fonts[MontserratMedium]}
            size={"large"}
            value={state.email}
            placeholder={"Email"}
            label="Email"
            disabled={true}
            name="email"
          />
        </Col>

        <Col span={24}>
          <Text.Basic
            fontSize={18}
            fontWeight={600}
            fontFamily={Fonts[MontserratBold]}
            text={"Message"}
            textAlign="left"
          />

          <TextField.Textarea
            name="message"
            className={"mt-10"}
            value={state.message}
            placeholder={"Write your message here"}
            rows={4}
            handleChange={handleChange}
          />
          {error.messageError && <Text.Error text={error.messageError} />}
        </Col>

        <Col span={24}>
          <Button.Basic
            size={"large"}
            buttonStyle={{
              backgroundColor: Colors.BlueText,
              color: Colors.White,
              width: "100%",
              height: "50px",
              fontSize: "16px",
              fontFamily: Fonts[PoppinsMedium],
              borderRadius: "10px",
              border: "none",
            }}
            loading={artist?.isLoading}
            disabled={artist?.isLoading}
            text={"Send"}
            onClick={handleSubmit}
          />
        </Col>
      </Row>
    </>
  );
};

export default ArtistEmail;
